var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { Vue, Component, Ref } from "vue-facing-decorator";
import { LicenseClient, AssureEditionEnum, LicenseStatus, MonitorTypeEnum, BatteryTypeEnum } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import SystemCoverageModal from "@/app/vues/components/system-coverage-modal.vue";
import moment from 'moment';
const licenseClient = new LicenseClient(window.apiUrl);
let AboutLicenseTab = class AboutLicenseTab extends Vue {
    constructor() {
        super(...arguments);
        this.license = null;
        this.featureConstraints = null;
        this.editionDescriptionMap = {
            [AssureEditionEnum.OnPremBasic]: 'On-Prem Basic',
            [AssureEditionEnum.OnPremStandard]: 'On-Prem Standard',
            [AssureEditionEnum.OnPremPremium]: 'On-Prem Premium',
            [AssureEditionEnum.PowershieldCloudStandard]: 'Powershield Cloud Standard',
            [AssureEditionEnum.Unknown]: 'Unknown'
        };
    }
    created() {
        this.loadData();
    }
    loadData() {
        return __awaiter(this, void 0, void 0, function* () {
            this.$emit("loadingChanged", true);
            try {
                yield Promise.all([
                    this.getLicense(),
                    this.getFeatureConstraints()
                ]);
            }
            finally {
                this.$emit("loadingChanged", false);
            }
        });
    }
    getLicense() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield licenseClient
                .getLicense()
                .then(response => {
                this.license = response;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            });
        });
    }
    getFeatureConstraints() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield licenseClient
                .getFeatureConstraints()
                .then(response => {
                this.featureConstraints = response;
            })
                .catch(ex => {
                console.warn("Failed to load feature constraints:", ex);
            });
        });
    }
    get isSystemConstrainedEdition() {
        var _a, _b, _c, _d;
        if (!((_b = (_a = this.license) === null || _a === void 0 ? void 0 : _a.activeLicense) === null || _b === void 0 ? void 0 : _b.assureEdition))
            return false;
        if (!((_d = (_c = this.featureConstraints) === null || _c === void 0 ? void 0 : _c.constrainedEditions) === null || _d === void 0 ? void 0 : _d.length))
            return false;
        return this.featureConstraints.constrainedEditions.includes(this.license.activeLicense.assureEdition);
    }
    get isRejectedLicenseSystemConstrained() {
        var _a, _b, _c, _d;
        if (!((_b = (_a = this.license) === null || _a === void 0 ? void 0 : _a.rejectedLicense) === null || _b === void 0 ? void 0 : _b.assureEdition))
            return false;
        if (!((_d = (_c = this.featureConstraints) === null || _c === void 0 ? void 0 : _c.constrainedEditions) === null || _d === void 0 ? void 0 : _d.length))
            return false;
        return this.featureConstraints.constrainedEditions.includes(this.license.rejectedLicense.assureEdition);
    }
    get statusAlertClass() {
        if (!this.license)
            return 'alert-primary';
        switch (this.license.status) {
            case LicenseStatus.Valid: return 'alert-success';
            case LicenseStatus.DefaultLicense: return 'alert-warning';
            case LicenseStatus.InGracePeriod: return 'alert-warning';
            case LicenseStatus.FileNotFound: return 'alert-primary';
            default: return 'alert-danger';
        }
    }
    formatDate(unixTimestamp) {
        if (!unixTimestamp)
            return 'N/A';
        return moment.unix(unixTimestamp).format('DD MMM YYYY');
    }
    formatGracePeriod(seconds) {
        if (!seconds)
            return 'N/A';
        const days = Math.floor(seconds / (24 * 60 * 60));
        return `${days} days`;
    }
    formatEdition(edition) {
        var _a;
        if (edition === undefined)
            return 'Unknown';
        return (_a = this.editionDescriptionMap[edition]) !== null && _a !== void 0 ? _a : 'Unknown';
    }
    formatMonitorType(monitorType) {
        var _a;
        if (monitorType === undefined)
            return 'Unknown';
        const types = {
            [MonitorTypeEnum.Sentinel]: 'Powershield Sentinel',
            [MonitorTypeEnum.Controller]: 'Powershield Controller',
            [MonitorTypeEnum.Cellwatch]: 'Cellwatch'
        };
        return (_a = types[monitorType]) !== null && _a !== void 0 ? _a : 'Unknown';
    }
    formatBatteryType(batteryType) {
        var _a;
        if (batteryType === undefined)
            return 'Unknown';
        const types = {
            [BatteryTypeEnum.LeadAcid]: 'Lead-Acid',
            [BatteryTypeEnum.Lithium]: 'Lithium'
        };
        return (_a = types[batteryType]) !== null && _a !== void 0 ? _a : 'Unknown';
    }
    getTotalStringCount(stringCounts) {
        if (!stringCounts)
            return 0;
        return stringCounts.reduce((total, quota) => total + quota.stringCount, 0);
    }
};
__decorate([
    Ref(),
    __metadata("design:type", typeof (_a = typeof InstanceType !== "undefined" && InstanceType) === "function" ? _a : Object)
], AboutLicenseTab.prototype, "systemCoverageModal", void 0);
AboutLicenseTab = __decorate([
    Component({
        name: "AboutLicenseTab",
        components: {
            SystemCoverageModal
        },
        emits: ["loadingChanged"]
    })
], AboutLicenseTab);
export default AboutLicenseTab;
